import { Link } from "gatsby"
import React from "react"
import style from "./footer.module.css"

const Footer = () => (
  <footer className={style.footer}>
    <div className={style.links}>
        <ul>
            <li><Link to="/gettingstarted">Getting started</Link></li>
        </ul>
    </div>
    <div className={style.policy}>
        <ul>
            <li><Link to="/privacynotice">Privacy Policy</Link></li>
        </ul>
    </div>
    <div className={style.copyright}>
      {/* <p>App designed and developed by Armando Brito</p> */}
      <p>For issues and suggestions please contact me at <a href="mailto:armando.brito.developer@gmail.com">armando.brito.developer@gmail.com</a></p>
      <p>Apple, the Apple logo and iPhone are trademarks of Apple Inc., registered in the U.S. and other countries and regions. App Store is a service mark of Apple Inc.</p>
      <p>Montserrat font was designed by Julieta Ulanovsky and was released with Open Font License. You can find it <a href="https://fonts.google.com/specimen/Montserrat?selection.family=Montserrat">here</a>.</p>
      <p>Noto Sans TC font was designed by Google and was released with Open Font License. You can find it <a href="https://fonts.google.com/specimen/Noto+Sans+TC">here</a>.</p>
      <p className={style.main}>© {new Date().getFullYear()} Armando Brito. All rights reserved.</p>
    </div>
  </footer>
)

export default Footer
